const convertToFlatTreeSelectData = (data: any) => {
  return [
    ...data.map((item: any) => ({
      label: item.title,
      key: item.id,
    })),
  ];
};

export default convertToFlatTreeSelectData;
